import axios from 'axios'
import React, { useState } from 'react'
import configs from '../../config'
import Cookies from 'js-cookie'
import { Card, Row, Col, Table } from 'react-bootstrap'
import OrderChangeStatus from './OrderChangeStatus'
import * as uuid from 'uuid'

const Header = {
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    Authorization: `Bearer ${Cookies.get('accessToken')}`,
  },
}

const OrderDetail = ({ order, onCancel }) => {
  const [status, setStatus] = useState(order.status)
  const submitPaymentDate =
    order.submitPaymentAt && new Date(order.submitPaymentAt._seconds * 1000).toLocaleString('TH-th')

  const handleOnClickOrderStatus = (value) => {
    setStatus(value.status)
  }

  const handleCancel = () => {
    onCancel()
  }

  const changeStatusOrder = async () => {
    const response = await axios.patch(
      `${configs.baseAPIExists}/admin/extras/orders/${order.orderId}`,
      { status: status },
      Header,
    )
    if (response.status === 204) {
      onCancel()
    }
  }
  return (
    <>
      <Card className="p-4" style={{ marginBottom: '130%' }}>
        <Card.Header>
          <Card.Title>คำสั่งซื้อ #{order.ref}</Card.Title>
        </Card.Header>
        <Card.Body>
          <div className="d-flex position-relative w-100 h-100" style={{ overflowX: 'scroll' }}>
            <div
              className="d-flex flex-column position-absolute"
              style={{
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px',
                marginRight: '15px',
              }}
            >
              <Row>
                <Col>
                  <div className="border-bottom mb-2">
                    <h4>ข้อมูลลูกค้า</h4>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="d-flex">
                    <ul className="w-100">
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>{order.shippingAddress.name}</div>
                          <div>{order.userId}</div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>{order.shippingAddress.phone}</div>
                          <div>{order.user?.name}</div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="border-bottom mt-4 mb-2">
                    <h4>ข้อมูลการสั่งซื้อ</h4>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="d-flex">
                    <ul className="w-100">
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>วันที่ซื้อ</div>
                          <div>{new Date(order.createdAt).toLocaleString('TH-th')}</div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>วันที่ส่งหลักฐาน</div>
                          <div>{order.submitPaymentAt ? submitPaymentDate : '-'}</div>
                        </div>
                      </li>
                      <li>
                        {order.status === 'success' && (
                          <div
                            className="d-flex justify-content-between align-items-center"
                            style={{ marginBottom: '8px' }}
                          >
                            <div>วันที่ยืนยันคำสั่งซื้อ</div>
                            <div>{order.approvedAt ? order.approvedAt : '-'}</div>
                          </div>
                        )}
                        {order.status === 'cancelled' && (
                          <div
                            className="d-flex justify-content-between align-items-center"
                            style={{ marginBottom: '8px' }}
                          >
                            <div>วันที่ยกเลิกคำสั่งซื้อ</div>
                            <div>{new Date(order.cancelledAt).toLocaleString('TH-th')}</div>
                          </div>
                        )}
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="border-bottom mt-3 mb-2">
                    <h4>รายการตรวจสอบ</h4>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="d-flex w-100">
                    <ul className="d-flex flex-column w-100">
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>Slip Reference Number</div>
                          <div>{order.transRef || order.tempTransRef || ''}</div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div className="d-flex" style={{ width: '210px', minWidth: '210px' }}>
                            สถานะตรวจสอบสลิปอัตโนมัติ
                          </div>
                          <div style={{ fontSize: '14px' }}>{order.verifyMessage}</div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="d-flex justify-content-between align-items-center"
                          style={{ marginBottom: '8px' }}
                        >
                          <div>สถานะ : </div>
                          <div>
                            {order.status === 'success' ? (
                              <span className="text-success">ซื้อสำเร็จ </span>
                            ) : order.status === 'cancelled' ? (
                              <span className="text-danger">ยกเลิก</span>
                            ) : order.status === 'processing' ? (
                              <span className="text-secondary">กำลังดำเนินการจัดส่ง</span>
                            ) : order.status !== 'pending' && order.status !== 'receipt attached' ? (
                              <span className="text-success">{order.status}</span>
                            ) : (
                              <OrderChangeStatus
                                order={order}
                                defaultStatus={order.status}
                                workingStatus={status}
                                onClick={(value) => handleOnClickOrderStatus(value)}
                              />
                            )}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <li>
                    <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: '8px' }}>
                      <div>ยอดรวม</div>
                      <h3 style={{ color: 'red' }}>{`${order.totalPrice} บาท`}</h3>
                    </div>
                  </li>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="border-bottom mt-4 mb-2">
                    <h3>หลักฐานการโอนเงิน</h3>
                  </div>
                </Col>
              </Row>
              <Row>
                {order.evidence ? (
                  <Col>
                    <div
                      style={{
                        justifyContent: 'center',
                        display: 'flex',
                      }}
                    >
                      <img
                        src={`${order.evidence}`}
                        style={{
                          maxWidth: '360px',
                          maxHeight: '600px',
                        }}
                        alt="slip"
                      />
                    </div>
                  </Col>
                ) : (
                  <Col>
                    <div
                      style={{
                        marginBottom: '8px',
                        textAlign: 'center',
                        color: 'red',
                      }}
                    >
                      ไม่พบสลิปสำหรับคำสั่งซื้อ #{order.ref}
                    </div>
                  </Col>
                )}
              </Row>
              <Row>
                <Col>
                  <div className="border-bottom mt-4 mb-2">
                    <h3>รายละเอียดการสั่งซื้อ</h3>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Table responsive striped className="verticle-middle">
                    <thead>
                      <tr>
                        <th>ชื่อสินค้า</th>
                        <th>ไซส์</th>
                        <th>จำนวน</th>
                      </tr>
                    </thead>
                    <tbody>
                      {order.items.map((value, i) => {
                        return (
                          <tr key={uuid.v4()}>
                            <td>{value.name}</td>
                            <td>{value.size}</td>
                            <td>{value.amount}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </div>
          </div>
        </Card.Body>
        {order.status !== 'success' && order.status !== 'cancelled' && (
          <Card.Footer>
            <div className="d-flex justify-content-end">
              <button className="btn btn-dark mr-2" onClick={handleCancel}>
                ยกเลิก
              </button>
              <button className="btn btn-primary" onClick={() => changeStatusOrder()}>
                ยืนยัน
              </button>
            </div>
          </Card.Footer>
        )}
      </Card>
    </>
  )
}

export default OrderDetail
